import { componentLoader } from "components/helper";
import AIDashboard from "pages/aiDashboard";
import BillingInvoices from "pages/billingInvocies";
import BillingReport from "pages/billingReport";
import { lazy } from "react";

const Reports = lazy(() => componentLoader(() => import("pages/Reports")));
const PostPayment = lazy(() =>
  componentLoader(() => import("pages/PostPayment")),
);
const ChargeEntryReports = lazy(() =>
  componentLoader(() => import("pages/ChargeEntryReports")),
);
const Analytics = lazy(() => componentLoader(() => import("pages/Analytics")));
const NotFound = lazy(() => componentLoader(() => import("pages/NotFound")));
const ChargeEntryScreen = lazy(() =>
  componentLoader(() => import("pages/ChargeEntryScreen")),
);
const Dashboard = lazy(() => componentLoader(() => import("pages/Dashboard")));
const TextToSpeech = lazy(() =>
  componentLoader(() => import("pages/TextToSpeech")),
);
const Encounter = lazy(() =>
  componentLoader(() => import("pages/Encounter.js")),
);
const TabsList = lazy(() =>
  componentLoader(() => import("pages/practice/TabsList")),
);
const Settings = lazy(() => componentLoader(() => import("pages/Settings.js")));
const Era = lazy(() => componentLoader(() => import("pages/Era.js")));
const ClaimsDashboard = lazy(() =>
  componentLoader(() => import("pages/ClaimsDashboard.js")),
);
const Documents = lazy(() =>
  componentLoader(() => import("pages/Documents.js")),
);
const EraDataEdit = lazy(() =>
  componentLoader(() => import("pages/EditEraData.js")),
);
const EditDocuments = lazy(() =>
  componentLoader(() => import("pages/EditDocuments")),
);
const ReportPage = lazy(() =>
  componentLoader(() => import("pages/ReportPage")),
);
const Payer = lazy(() => componentLoader(() => import("pages/Payer")));
const TaggedClaims = lazy(() =>
  componentLoader(() => import("pages/TaggedClaims")),
);
const PracticePreference = lazy(() =>
  componentLoader(() => import("pages/settings/PracticePreference")),
);
const UserManagement = lazy(() =>
  componentLoader(() => import("pages/settings/UserManagement")),
);
const BillingBatchReport = lazy(() =>
  componentLoader(() => import("pages/BillingBatchReport")),
);
const AdminDashboard = lazy(() =>
  componentLoader(() => import("pages/superAdmin/AdminDashboard")),
);
const PracticeDetails = lazy(() =>
  componentLoader(() => import("pages/superAdmin/PracticeDetails")),
);

const routesArray = [
  {
    path: "/",
    isExact: true,
    component: Dashboard,
  },
  {
    path: "/dashboard",
    isExact: false,
    component: Dashboard,
  },
  {
    path: "/ai-dashboard",
    isExact: false,
    component: AIDashboard,
  },
  {
    path: "/practice-settings",
    isExact: false,
    component: TabsList,
  },
  {
    path: "/encounter",
    isExact: false,
    component: Encounter,
  },
  {
    path: "/documents",
    isExact: false,
    component: Documents,
  },
  {
    path: "/editEraData",
    isExact: false,
    component: EraDataEdit,
  },
  {
    path: "/era",
    isExact: false,
    component: Era,
  },
  {
    path: "/appointments",
    isExact: false,
    component: NotFound,
  },
  {
    path: "/charge-entry",
    isExact: false,
    component: ChargeEntryScreen,
  },
  {
    path: "/reports",
    isExact: true,
    component: Reports,
  },
  {
    path: "/charge-entry-reports",
    isExact: false,
    component: ChargeEntryReports,
  },
  {
    path: "/analytics",
    isExact: false,
    component: Analytics,
  },
  {
    path: "/speech",
    isExact: false,
    component: TextToSpeech,
  },
  {
    path: "/notFound",
    isExact: false,
    component: NotFound,
  },
  {
    path: "/claims-dashboard",
    isExact: false,
    component: ClaimsDashboard,
  },
  {
    path: "/edit-document",
    isExact: false,
    component: EditDocuments,
  },
  {
    path: "/payer",
    isExact: true,
    component: Payer,
  },
  {
    path: "/tagged-claims",
    isExact: true,
    component: TaggedClaims,
  },
  {
    path: "/reports/:id",
    isExact: true,
    component: ReportPage,
  },
  {
    path: "/post-payment",
    isExact: false,
    component: PostPayment,
  },
  {
    path: "/charge-entry/:patient_id/:charge_entry_id",
    isExact: true,
    component: ChargeEntryScreen,
  },
  {
    path: "/settings",
    isExact: true,
    component: Settings,
  },
  {
    path: "/user-management",
    isExact: true,
    component: UserManagement,
  },
  {
    path: "/billing-reports",
    isExact: true,
    component: BillingReport,
  },
  {
    path: "/billing-batch-report",
    isExact: false,
    component: BillingBatchReport,
  },
  {
    path: "/practice-preference",
    isExact: true,
    component: PracticePreference,
  },
  {
    path: "/billing-Invoices",
    isExact: true,
    component: BillingInvoices,
  },
];

const adminRoutesArray = [
  {
    path: "/admin/dashboard",
    isExact: true,
    component: AdminDashboard,
  },
  {
    path: "/admin/practice-details",
    isExact: true,
    component: PracticeDetails,
  },
];

export { routesArray, adminRoutesArray };
